import type { OfferBenefit } from "../types"

/** Three icon + title + subtitle rows under the hero. */
export function OfferBenefits({ items }: { items: OfferBenefit[] }) {
  return (
    <div data-slot="offer-benefits" className="flex flex-col gap-4">
      {items.map((item) => (
        <div key={item.title} className="flex h-16 items-center gap-4">
          <img src={item.icon} alt="" className="size-14 shrink-0" />
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <h3 className="font-display text-base font-medium text-purple-light">{item.title}</h3>
            <p className="text-sm leading-snug text-purple-light/70">{item.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
